module.exports = __webpack_public_path__ + "static/media/second-prize.0ae72aec.png";